
import { BookYearService } from "@/services/book-year-service";
import { ChartService } from "@/services/chart-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ChartOpenByMonth, IOpenChartData } from "@/utils/chart-open-by-month";
import {AppApexChart} from "@/utils/apex-charts";
import Vue from "vue";
import { IOpen } from "@/utils/chart-open";

export default Vue.extend({
	data() {
		return {
			currentYear: null as ChartOpenByMonth | null,
		};
	},
	props: {
		showPrevYear: Boolean,
		chartData: Object as () => IOpen,
		chartType: {
			type: String,
			default: "bar",
		},
	},
	computed: {
		startMonth() {
			return DossierConfigService.getGeneralConfig().BookYearStartMonth;
		},
		displayData(): any[] {
			if (this.currentYear) {
				let thisYear = {
					data: this.currentYear.getOrderedData(this.startMonth)
				};
				return [thisYear];
			}
			let emptyIncome = [];
			for (let i = 0; i < 12; i++) {
				emptyIncome.push(0);
			}
			return [{
				name: "loading",
				data: emptyIncome
			}];
		},
		// eslint-disable-next-line max-lines-per-function
		chartOptions() {
			let months = [] as string[];
			for (let i = 0; i < 12; i++) {
				let monthNumber = i + 1 + this.startMonth;
				if (monthNumber > 12) {
					monthNumber -= 12;
				}
				months.push(this.$ct("common.months." + monthNumber).toString().substring(0, 3));
			}

			var dataLabelOptions = {};
			if (this.chartType == "bar") {
				dataLabelOptions = {
					enabled: true,
					formatter(val:any) {
						return val ? val : "";
					},
					offsetY: -20,
					style: {
						fontSize: "12px",
						colors: ["#304758"]
					}
				};
			}

			return {
				chart: {
					toolbar: {
						show: false
					}
				},
				grid: {},
				yaxis: {},
				stroke: {},
				plotOptions: {
					bar: {
						dataLabels: {
							position: "top"
						}
					}
				},
				dataLabels: dataLabelOptions,
				xaxis: {

					categories: months,
					crosshairs: {show: false},
					axisBorder: {
						show: false
					},
					axisTicks: {color: "#ededed"},
					labels: {
						style: {

							fontFamily: "Arial",
							fontSize: "14px",
							"-webkit-font-smoothing": "antialiased"
						}
					}
				},


			};
		},
	},
	watch: {
		chartData() {
			this.fetch();
		}
	},
	methods: {
		async fetch() {
			let result = this.chartData ? this.chartData : await ChartService.getOpen();
			this.currentYear = new ChartOpenByMonth(result.TotalOpenByMonth as IOpenChartData[]);
		}
	},
	async mounted() {
		//BookYearService.$on("bookyear-changed", this.fetch);
		//await this.$nextTick();
		if (this.chartType == "bar") {

		}
		this.fetch();
	},
	beforeDestroy() {
		BookYearService.off("bookyear-changed", this.fetch);
	},
	components: {
		AppApexChart
	},
	i18nEx: {
		componentPrefix: "components.charts-IncomeChart"
	}
});
